import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Paper,
  Typography,
  IconButton,
} from '@mui/material';
import {
  CloudUpload,
  Download,
} from '@mui/icons-material';
import { PaginationModel } from 'utils/PaginationType';
import { UploadHistory } from './PointsManagementType';
import ShireTable from 'components/ShireTable';
import { getUploadHistory, downloadUploadFile } from 'services/PointsManagementService';
import UploadFileModal from './UploadFileModal';
import { PointsManagementColumns } from './PointsManagementModel';

const PointsManagement: React.FC = () => {
  const [paginationModel, setPaginationModel] = useState<PaginationModel>({
    page: 0,
    pageSize: 10,
    rowCount: 0,
  });
  const [uploadHistory, setUploadHistory] = useState<UploadHistory[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openPointsManagementDetailModal, setOpenPointsManagementDetailModal] = useState(false);

  useEffect(() => {
    fetchUploadHistory(paginationModel.page + 1, paginationModel.pageSize);
  }, [paginationModel.page, paginationModel.pageSize]);

  const fetchUploadHistory = async (page: number, pageSize: number) => {
    try {
      const response = await getUploadHistory(page, pageSize);
      setUploadHistory(response.records);
      setTotalRecords(response.total);
    } catch (error) {
      console.error('Failed to fetch upload history:', error);
    }
  };

  const handleUploadSuccess = () => {
    // Refresh the table data
    fetchUploadHistory(paginationModel.page + 1, paginationModel.pageSize);
  };

  const handleDownload = async (fileUrl: string) => {
    try {
      await downloadUploadFile(fileUrl);
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  };

  const handleOpenDetailModal = (id: number) => {
    console.log('Open detail modal for id:', id);
  };

  return (
    <>
      <Typography variant="h4" sx={{ marginBottom: 3 }}>
        Quản lý tích điểm
      </Typography>

      <Paper elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
          <Typography variant="h6" sx={{ alignSelf: 'center' }}>
            Lịch sử upload
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloudUpload />}
            onClick={() => setOpenUploadModal(true)}
          >
            Upload file bán hàng
          </Button>
        </Box>

        <ShireTable
          columns={PointsManagementColumns(handleDownload, handleOpenDetailModal)}
          rows={uploadHistory}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={false}
        />
      </Paper>

      <UploadFileModal
        open={openUploadModal}
        onClose={() => setOpenUploadModal(false)}
        onUploadSuccess={handleUploadSuccess}
      />
    </>
  );
};

export default PointsManagement;
